/**
 * Shared helpers for notification display & navigation.
 */

import { UserMenu } from '../../menu';

interface NotifStyleResult {
  icon: string;
  bg: string;       // soft bg for unread / active
}

/**
 * Return icon + soft background color based on notification type.
 */
export function getNotifStyle(type: string): NotifStyleResult {
  switch (type) {
    case 'reject':
      return { icon: '❌', bg: '#ffebee' };
    case 'cr':
      return { icon: '✏️', bg: '#fff3e0' };
    case 'approval':
      return { icon: '👍', bg: '#e8f5e9' };
    case 'feedback':
      return { icon: '💬', bg: '#fff8e1' };
    default:
      return { icon: '🔔', bg: '#e3f2fd' };
  }
}

/**
 * Tentukan path tujuan berdasarkan tipe notifikasi dan menu user.
 * Mapping: tipe notif → cari path dari UserMenu (role-based dari localStorage).
 */
export function getNotifPath(type: string): string {
  // Approval → cari halaman approval yg tersedia: Legal Head > Legal FA > Dept Appv
  if (type === 'approval') {
    const priorityKeys = ['legal_legalhead', 'legal_legalfa', 'legal_legaldept'];
    for (const key of priorityKeys) {
      if (UserMenu[key]?.path) return UserMenu[key].path;
    }
    return '/';
  }

  // Feedback → My List (creator perlu kasih feedback)
  if (type === 'feedback') {
    return UserMenu?.legal_mylist?.path || '/';
  }

  // Change request → My List (creator) atau Legal Draft (legal officer)
  if (type === 'cr') {
    if (UserMenu?.legal_legaldraft?.path) return UserMenu.legal_legaldraft.path;
    return UserMenu?.legal_mylist?.path || '/';
  }

  // Reject / default → My List
  return UserMenu?.legal_mylist?.path || '/';
}
